import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const ActivityParticipation = ({ t }) => {
  const data = [
    { name: "رياضة مائية", value: 12, color: "#D1A855" },
    { name: "لياقة", value: 4, color: "#6B774A" },
    { name: "رياضة جماعية", value: 2, color: "#3b82f6" },
    { name: "فعاليات VIP", value: 1, color: "#ec4899" },
  ];

  return (
    <section className="border border-[#374151] rounded-2xl p-6 shadow-md mainLinear w-full">
      <h2 className="my-3 font-semibold text-primary">{t("activityParticipation")}</h2>
      <div>
        <div className="w-40 h-40 mx-auto">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Tooltip formatter={(value, name) => [value, name]} />
              <Pie
                data={data}
                dataKey="value"
                innerRadius={50}
                outerRadius={75}
                paddingAngle={4}
                stroke="white"
                strokeWidth={2}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="flex items-center justify-between gap-4 my-4 mt-8 text-right">
          {data.map((entry, index) => (
            <div
              key={index}
              className="flex items-center space-x-2 rtl:space-x-reverse"
            >
              <span
                className="block w-[6px] h-5 rounded"
                style={{ backgroundColor: entry.color }}
              />
              <span className="text-sm text-gray-300">{entry.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ActivityParticipation;
